import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import StoryblokImage from './storyblok-image';

// Generic standalone image block, used e.g. as the illustration on the 404 page.
export default function ImageBlock({ blok }) {
  if (!blok?.image?.filename) return null;

  return (
    <div {...storyblokEditable(blok)} className="order-first mb-8 flex justify-center lg:mb-10">
      <StoryblokImage
        src={blok.image}
        alt={blok.image.alt}
        className="w-full h-full"
        sizes="(max-width: 1024px) 280px, 384px"
      />
    </div>
  );
}
